/**
 * Target guards for gesture start gating: resolve a gesture `EventTarget` to an
 * element and ask the canonical editability predicates about it. The "what
 * counts as editable" logic lives in `@/lib/dom/editable` — this file only
 * adapts it to event targets. Pure DOM predicates — no Solid, no recognizer.
 */

import { isEditableElement } from "@/lib/dom/editable";

export { isEditingActive } from "@/lib/dom/editable";

function asElement(target: EventTarget | null): Element | null {
  if (target instanceof Text) {
    return target.parentElement;
  }
  return target instanceof Element ? target : null;
}

/** True if `target` (or an ancestor) matches `selector`.*/
export function closestSelector(target: EventTarget | null, selector: string): boolean {
  const el = asElement(target);
  return Boolean(el?.closest(selector));
}

/** True if `target` itself is a form control / contenteditable.*/
export function isEditableTarget(target: EventTarget | null): boolean {
  return isEditableElement(asElement(target));
}
